import React from "react";

const openingDay   = "Thursday, January 21, 2027";
const closingDay   = "Sunday, January 24, 2027";
const openingTime  = "5:00 pm Pacific Time (PT)";
const closingTimes = [
  { time: "8:30 am PT", note: "Movement and Meditation" },
  { time: "10:30 am PT", note: "Closing Session" },
];

const dailySchedule = [
  { time: "8:30 am PT", note: "Movement and Meditation" },
  { time: "10:30 am PT", note: "Eating Together" },
  { time: "Afternoons", note: "Break time for activities announced daily" },
  { time: "3:00 pm PT", note: "Group Sessions" },
  { time: "5:30 pm PT", note: "Evening Session" },
];

export default function Schedule() {
  return (
    <section className="bg-white py-12 sm:py-24 px-4 sm:px-[10%]">
      <div className="max-w-5xl mx-auto space-y-6 sm:space-y-8">
        <h2 className="text-left">
          <span className="font-century font-normal text-3xl sm:text-4xl">
            Schedule:
          </span>{" "}
          <span className="font-century font-normal text-xl sm:text-2xl">
            January&nbsp;21 – 24, 2027
          </span>
        </h2>
        <p className="font-roboto font-normal text-base sm:text-lg text-left">
          Throughout the retreat, you will be with Geneen for intensive
          teachings. Starting with gentle movement and meditation, the daily
          schedule features interactive group sessions with Geneen. One of the
          highlights are the daily eating meditations, sharing a meal together
          (virtually) guided by Geneen.
        </p>
        <div className="space-y-4 sm:space-y-6">
          <h3 className="font-roboto font-medium text-lg sm:text-xl text-left">
            The retreat starts on {openingDay}:
          </h3>
          <p className="font-roboto font-normal text-base sm:text-lg text-left">
            {openingTime} &nbsp;–&nbsp; Opening Session
          </p>
        </div>
        <div className="space-y-4 sm:space-y-6">
          <h3 className="font-roboto font-medium text-lg sm:text-xl text-left">
            The daily schedule Friday and Saturday (subject to change):
          </h3>
          <div className="mt-2 sm:mt-4 rounded-lg bg-[#9AEEDA33] p-4 sm:p-6 overflow-x-auto">
            <table className="min-w-[320px] w-full text-left border-collapse">
              <thead>
                <tr>
                  <th className="font-roboto font-medium text-base sm:text-lg py-2 pr-4">
                    Time
                  </th>
                  <th className="font-roboto font-medium text-base sm:text-lg py-2">
                    Activity
                  </th>
                </tr>
              </thead>
              <tbody>
                {dailySchedule.map(({ time, note }, idx) => (
                  <tr key={idx}>
                    <td className="font-roboto font-normal text-base sm:text-lg py-2 pr-4 whitespace-nowrap">
                      {time}
                    </td>
                    <td className="font-roboto font-normal text-base sm:text-lg py-2">
                      {note}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className="space-y-4 sm:space-y-6">
          <h3 className="font-roboto font-medium text-lg sm:text-xl text-left">
            The retreat ends on {closingDay}:
          </h3>
          <ul className="font-roboto font-normal text-base sm:text-lg text-left space-y-2">
            {closingTimes.map(({ time, note }, idx) => (
              <li key={idx}>
                <span className="whitespace-nowrap">{time}</span> &nbsp;–&nbsp;{note}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}